import { type RefObject, useEffect, useState } from 'react';

import {
  computeSignatureCanvasDimensions,
  getDefaultSignatureCanvasDimensions,
  type SignatureCanvasDimensions,
} from './signature-canvas-dimensions';

function readContainerWidth(element: HTMLElement): number {
  const { width } = element.getBoundingClientRect();

  return width;
}

export function useSignatureCanvasDimensions(
  containerRef: RefObject<HTMLElement | null>,
  enabled: boolean,
): SignatureCanvasDimensions {
  const [dimensions, setDimensions] = useState<SignatureCanvasDimensions>(() => getDefaultSignatureCanvasDimensions());

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const element = containerRef.current;

    if (!element) {
      return;
    }

    const updateDimensions = () => {
      const next = computeSignatureCanvasDimensions(readContainerWidth(element));

      if (next) {
        setDimensions(next);
      }
    };

    updateDimensions();

    const observer = new ResizeObserver(() => {
      updateDimensions();
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [containerRef, enabled]);

  return dimensions;
}
